/**
 * Returns a date formatted as "YYYY-MM-DD" in the Europe/Amsterdam timezone.
 * Use this instead of new Date() / moment() for "today" so that users in other
 * timezones (e.g. USA) see the same calendar date as the NL server.
 */
export function getNLDateString(date: Date = new Date()): string {
    // 'en-CA' locale produces the ISO YYYY-MM-DD format natively.
    return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Amsterdam' }).format(date);
}

/**
 * Parses a "YYYY-MM-DD" string (as returned by the API) into a local Date at noon.
 *
 * Why noon?  `new Date("2026-06-15")` is parsed as UTC *midnight*, which in timezones
 * west of UTC (e.g. US East = UTC-5) becomes June 14 at 19:00 local time — causing
 * getDate() / getDay() / getMonth() to return the wrong day.  Creating the date at
 * local noon guarantees that local calendar methods always return the intended date
 * regardless of the user's UTC offset (covers UTC-11 … UTC+12).
 */
export function parseAPIDate(dateString: string): Date {
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day, 12, 0, 0);
}

